import _extends from "@babel/runtime/helpers/extends";
import { arrayOf, bool, func, instanceOf, object, oneOf, oneOfType, shape, string, number } from "prop-types";
export var formFieldPropTypes = shape({
  // Default "empty" value for any field is an empty string.
  // `attachment`, if filled in, will have a browser File object as a value
  value: oneOfType([string, instanceOf(File)]).isRequired,
  isRequired: bool.isRequired,
  isTouched: bool.isRequired,
  isValid: bool.isRequired
}); // We export this separately as we'll detect these keys when initializing an
// instance of <Pac /> to ensure our config values exist.

var pacProps = {
  // api props
  //
  // Note: apps who use Pac are required to be use ixAuth for authenticating
  // requests through the platform. So we send along the ixAuth cookie making
  // Basic auth unnecessary.
  apiRoot: string,
  apiIxlibraryUrl: string.isRequired,
  apiIxlibraryBaseUrl: string,
  apiRulesetsUrl: string.isRequired,
  apiIxvocabAuth: string,
  apiIxvocabUrl: string.isRequired,
  apiPoliciesUrl: string,
  apiPxcentralUrl: string.isRequired,
  apiQuotingUrl: string.isRequired,
  apiAddressServicingUrl: string.isRequired,
  // other
  applicationId: string.isRequired,
  attachmentSizeLimitMB: number,
  username: string.isRequired,
  enableRulesets: bool,
  handleExternalClose: func.isRequired,
  policyActionSavedCallback: func,
  policyActionId: string.isRequired,
  policyActionLabel: string.isRequired,
  productId: string.isRequired,
  showCopyChangedFields: bool,
  showEffectiveDateButtons: bool,
  // @TODO could probably do an even stricter check here...
  policyXmlDom: instanceOf(XMLDocument).isRequired,
  columnData: object,
  columnDataTitle: string
};
export var pacPropTypeDefaults = {
  attachmentSizeLimitMB: 10,
  apiIxlibraryBaseUrl: ""
};
export var pacPropTypes = pacProps;
export var pacDataPropTypes = shape(_extends({}, Object.keys(pacProps).reduce(function (acc, key) {
  var _extends2;

  return key === "policyXmlDom" ? acc : _extends({}, acc, (_extends2 = {}, _extends2[key] = pacProps[key], _extends2));
}, {}), {
  pacId: string.isRequired,
  policyData: shape({
    // These are the minimum values we know will be required. Other values
    // that are required vary depending on which form you're looking at
    ExpirationDate: string.isRequired,
    StartDate: string.isRequired,
    InsightPolicyId: string.isRequired,
    PolicyID: string.isRequired,
    Version: string.isRequired
  }).isRequired,
  rexFormMetadata: shape({
    // These values are mapped directly from the selector rex gives us, which is
    // why they are different casing.
    ixVocabContextId: string,
    PremiumBearingChange: oneOf(["true", "false", undefined]).isRequired,
    ReasonCodes: arrayOf(shape({
      name: string.isRequired,
      value: string.isRequired
    })),
    RequestHeaders: arrayOf(shape({
      name: string.isRequired,
      value: string.isRequired
    }))
  }),
  supplementalPolicyTerms: arrayOf(shape({
    label: string.isRequired,
    terms: arrayOf(shape({
      dataType: string.isRequired,
      description: string.isRequired,
      enumerations: object.isRequired,
      label: string.isRequired,
      name: string.isRequired
    }))
  }))
}));